import { getCurrentInstance } from 'vue';
import type { TouchVueUIOptions } from '../ui';

/**
 * 获取组件库全局配置
 * 可以在组件内部使用此函数获取全局配置
 * @returns 全局配置对象
 */
export const useGlobalConfig = (): TouchVueUIOptions => {
  const instance = getCurrentInstance();
  if (!instance) {
    console.warn('useGlobalConfig() 只能在setup()或生命周期钩子中调用');
    return {} as TouchVueUIOptions;
  }

  // 从应用实例中获取全局配置
  return instance.appContext.config.globalProperties.$TOUCHVUE_CONFIG || {};
};

/**
 * 获取组件配置
 * 合并全局配置和组件自身的props配置
 * @param props 组件props
 * @param key 配置键名
 * @returns 合并后的配置值
 */
export const getComponentConfig = <T>(props: Record<string, any>, key: string): T => {
  const globalConfig = useGlobalConfig();

  // 优先使用组件自身的props配置，如果没有则使用全局配置
  return (props[key] ?? globalConfig[key]) as T;
};
